//libs and utilities
import React from 'react';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import { BREAKPOINT } from '../app-lang';
import { Link } from 'react-router-dom';
import { fetchUserLogin, callLogoutApi } from './header-dux';

/*   Components
 *
 *   1. Header
 *   2. DesktopNav
 *
 */

export class Header extends React.Component {
    componentDidMount() {
		this.props.fetchUserLogin();
    }
	
	componentDidUpdate(){
		let windowLocation = window.location.pathname.split("/")[3];
		if(this.props.headerState == null && (windowLocation == "home" || windowLocation == "news" || windowLocation == "sales" || windowLocation == "about" || windowLocation == "profile")){
			window.location = window.location.origin + '/wholesalechannelpartners/'
		}
	}
	
	logoutSession = ( e ) => {
		this.props.callLogoutApi();
	}
	
    renderHamburger() {
		let data = this.props.header;
		let userDetails = data.logonInfo;
		const {location} = window;        
        let urlLocation = '';
        if(location.hostname === "localhost" && location.port == "3001") {
            urlLocation = "/login/";
        } else {
            urlLocation = location.origin + '/wholesalechannelpartners/';
        }
		return (
			<div className={this.props.headerState != null ? "topNav " +this.props.headerState.paxAudienceType : "topNav default"}>
				<nav className="navbar navbar-expand-lg navbar-light navbar-padding headermenu">
					{ this.renderBrandLogo() }
					
					{ userDetails != null &&
						<button className="navbar-toggler" type="button" data-toggle="collapse" data-target="#navbarNav" aria-controls="navbarNav" aria-expanded="false" aria-label="Toggle navigation" id="togglebutton">
							<span className="navbar-toggler-icon" />
						</button>
					}
					{ userDetails != null &&
						<div className="collapse navbar-collapse menualigncenter" id="navbarNav">
							<div className="userProfile mobile">
								<div className="username">Welcome, {userDetails.firstName} {userDetails.lastName}</div>
								<div className="links" data-toggle="collapse" data-target=".navbar-collapse.show"><Link to={urlLocation} onClick={this.logoutSession}>{data.headerLinkListCM[0].title}</Link> | <Link to={"/"+ data.headerLinkListCM[1].url }>{data.headerLinkListCM[1].title}</Link></div>
							</div>
							<ul className="navbar-nav nav" onClick={this.activeMenu}>
								{data.headerLinkListCM.slice(2).map((linkName, index) => {
									return <li key={index} className="nav-item" data-toggle="collapse" data-target=".navbar-collapse.show">{linkName.status == "A" ? 
									<Link to={ "/"+linkName.url } >
										{linkName.count && 
											<span className="count-indicator">{linkName.count}</span> 
										}	
											<span dangerouslySetInnerHTML={{ __html: linkName.title }}></span>
											</Link> : ''}
									</li>
								})}
							</ul>
						</div>
					}
				</nav>
				{ userDetails != null &&
					<div className="userProfile desktop">
						<div className="username">Welcome, {userDetails.firstName} {userDetails.lastName}</div>
						<div className="links"><Link to={urlLocation} onClick={this.logoutSession}>{data.headerLinkListCM[0].title}</Link> | <Link to={"/"+ data.headerLinkListCM[1].url }>{data.headerLinkListCM[1].title}</Link></div>
					</div>
				}
			</div>
		)
    }	
    
    renderBrandLogo() {
		let data = this.props.header;
		let userDetails = data.logonInfo;
		const {location} = window;        
        let imageLocation = '';
        if(location.hostname === "localhost" && location.port == "3001") {
            imageLocation = "images/";
        } else {
            imageLocation = location.origin + '/wholesalechannelpartners/images/';
        }
		
        return(
            <h1 className="logo">
				{ userDetails != null ? <Link to="/Home/" className="brand-logo">
					<div className="logo-primary pull-left">
						<img src={imageLocation+userDetails.paxAudienceType+"/primary-logo.jpg"} />
					</div></Link> : 
					<Link to={'/../'} className="brand-logo">
						<div className="logo-primary pull-left">
							<img src={imageLocation+"login-logo.jpg"} />
						</div>
					</Link>
				}
            </h1>
        );
    }
	
    render() {
        return(
            <header id="header">
                <div className="container">
                    { this.renderHamburger() }
                </div>
            </header>
        );
    }
}

export default connect(
    ( state ) => {
        return {
            header: state.headerState,
			headerState: state.headerState.audienceType
        };
    },
    ( dispatch ) => bindActionCreators( { fetchUserLogin, callLogoutApi }, dispatch )
)( Header );



// WEBPACK FOOTER //
// ./src/header/header.jsx